import { PayloadAction } from '@reduxjs/toolkit';
import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';

import ApprovalGateway from '~apis/approval';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';
import { TUpdateDiscountStatusReduxParams, TUpdateProductStatusReduxParams } from '~types/feat/approval';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages, SuccessMessages } from '~utils/constants';
import { TransactionStatusEnum } from '~utils/enums';

export default function* watchUpdateProductStatus(api: ApprovalGateway): SagaWatcherReturnType {
    yield takeEvery('approval/approvalUpdateProductStatusAttempt', handleUpdateProductStatus, api);
}

function* handleUpdateProductStatus(api: ApprovalGateway, data: PayloadAction<TUpdateProductStatusReduxParams>) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const {
        id,
        status,
    } = data.payload;

    const response = yield* call([api, api.updateProductStatus], {
        authToken,
        id,
        status,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.approvalUpdateProductStatusFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        const successMessage = status === TransactionStatusEnum.Approved
            ? SuccessMessages.SettingUpdateProductApprovalSuccess
            : status === TransactionStatusEnum.Rejected
                ? SuccessMessages.SettingUpdateProductRejectedSuccess
                : '';

        yield put(combinedActions.approvalSetConfirmUpdateProductStatusModalIsOpen(false));
        yield put(combinedActions.approvalGetPendingProductListingAttempt());
        yield put(combinedActions.approvalUpdateProductStatusSuccess());
        yield put(combinedActions.goldGetAllProductsAttempt());
        yield put(combinedActions.settingGetSettingsAttempt());

        toast.success(successMessage);
    }
}
